module.exports = __webpack_public_path__ + "static/media/klima-05.ce2562d8.jpg";